"use client";

import { c as _c } from "react/compiler-runtime";
import { Popover, PopoverContent, PopoverTrigger } from "fumadocs-ui/components/ui/popover";
import { Check, Languages } from "lucide-react";
import { useRouter } from "next/navigation";
import { useDocsI18n } from "@/lib/i18n";
import { cn } from "../lib/cn";
interface LanguageSwitcherProps {
  className?: string;
}
export function LanguageSwitcher(t0) {
  const $ = _c(25);
  const {
    className
  } = t0;
  const {
    locale,
    locales,
    localeLabels,
    setLocale,
    t
  } = useDocsI18n();
  const router = useRouter();
  let t1;
  if ($[0] !== t) {
    t1 = t("language.label");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className) {
    t2 = cn("inline-flex h-8 items-center gap-2 rounded-md border bg-fd-secondary px-2 text-xs font-medium text-fd-secondary-foreground transition-colors hover:bg-fd-accent hover:text-fd-accent-foreground", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Languages className="size-3.5 text-fd-muted-foreground" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = localeLabels[locale];
  let t5;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t4) {
    t5 = <PopoverTrigger aria-label={t1} className={t2}>{t3}{t4}</PopoverTrigger>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== locale || $[10] !== localeLabels || $[11] !== locales || $[12] !== router || $[13] !== setLocale) {
    let t7;
    if ($[15] !== locale || $[16] !== localeLabels || $[17] !== router || $[18] !== setLocale) {
      t7 = item => <button key={item} type="button" className={cn("flex items-center gap-2 rounded-md px-2 py-1.5 text-start text-sm hover:bg-fd-accent hover:text-fd-accent-foreground", item === locale && "font-medium")} onClick={() => {
        setLocale(item);
        router.refresh();
      }}><span className="flex-1">{localeLabels[item]}</span>{item === locale && <Check className="size-3.5" />}</button>;
      $[15] = locale;
      $[16] = localeLabels;
      $[17] = router;
      $[18] = setLocale;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    t6 = locales.map(t7);
    $[9] = locale;
    $[10] = localeLabels;
    $[11] = locales;
    $[12] = router;
    $[13] = setLocale;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[20] !== t6) {
    t7 = <PopoverContent align="end" className="flex min-w-32 flex-col p-1">{t6}</PopoverContent>;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t5 || $[23] !== t7) {
    t8 = <Popover>{t5}{t7}</Popover>;
    $[22] = t5;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}